import type React from 'react';
import { createContext } from 'react';
import { type InstanceConfig } from '@/routes/schools/types';

const InstanceConfigContext = createContext<
  [InstanceConfig | null, React.Dispatch<React.SetStateAction<InstanceConfig>>]
>([null, () => {}]);

export default InstanceConfigContext;
